module.exports = __webpack_public_path__ + "img/5.59ec8bb4.png";